import { UntypedFormGroup } from '@angular/forms';

export class PasswordModel {
  oldPassword: string;
  newPassword: string;

  populateFromFormGroup(formGroup: UntypedFormGroup): void {
    this.newPassword = formGroup.get('password')?.value;
    this.oldPassword = formGroup.get('current')?.value;
  }
}
